(() => {
  const ROOT_SELECTOR = '[data-native-carousel]';

  const getStep = (root, viewport) => {
    const slide = root.querySelector('[data-carousel-slide]');
    const container = root.querySelector('[data-carousel-container]');
    if (!slide) return viewport.clientWidth;

    const gap =
      container
        ? parseFloat(getComputedStyle(container).gap || '0') || 0
        : 0;

    return slide.getBoundingClientRect().width + gap;
  };

  const syncArrows = (viewport, prevBtn, nextBtn) => {
    const max = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
    const x = viewport.scrollLeft;

    const canScroll = max > 1;
    const canPrev = canScroll && x > 1;
    const canNext = canScroll && x < max - 1;

    if (prevBtn) prevBtn.hidden = !canPrev;
    if (nextBtn) nextBtn.hidden = !canNext;
  };

  const init = (root) => {
    if (!root) return;

    if (root.__nativeCarouselCleanup) root.__nativeCarouselCleanup();

    const viewport = root.querySelector('[data-carousel-viewport]');
    const prevBtn = root.querySelector('[data-carousel-prev]');
    const nextBtn = root.querySelector('[data-carousel-next]');
    if (!viewport) return;

    const onPrev = () => {
      viewport.scrollBy({
        left: 2 * -getStep(root, viewport),
        behavior: 'smooth',
      });
    };

    const onNext = () => {
      viewport.scrollBy({
        left: 2 * getStep(root, viewport),
        behavior: 'smooth',
      });
    };

    if (prevBtn) prevBtn.addEventListener('click', onPrev);
    if (nextBtn) nextBtn.addEventListener('click', onNext);

    let raf = 0;
    const onScroll = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => syncArrows(viewport, prevBtn, nextBtn));
    };

    viewport.addEventListener('scroll', onScroll, { passive: true });

    const ro = new ResizeObserver(() =>
      syncArrows(viewport, prevBtn, nextBtn)
    );
    ro.observe(viewport);

    root.__nativeCarouselCleanup = () => {
      if (prevBtn) prevBtn.removeEventListener('click', onPrev);
      if (nextBtn) nextBtn.removeEventListener('click', onNext);
      viewport.removeEventListener('scroll', onScroll);
      ro.disconnect();
      cancelAnimationFrame(raf);
      root.__nativeCarouselCleanup = null;
    };

    syncArrows(viewport, prevBtn, nextBtn);
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll(ROOT_SELECTOR).forEach(init);
  };

  const destroyAll = (scope = document) => {
    scope.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      if (root.__nativeCarouselCleanup) root.__nativeCarouselCleanup();
    });
  };

  document.addEventListener('DOMContentLoaded', () => initAll());

  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  document.addEventListener('shopify:section:unload', (e) =>
    destroyAll(e.target)
  );
})();
